import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import React from "react"
import { injectIntl } from "react-intl"
import { Redirect } from "react-router-dom"
import SideBar from "../common/layout/sidebar.component.jsx"
import InvoicesTabs from "../common/layout/tabs/invoices.component.jsx"
import GenericListing from "../common/listing/generic-listing/GenericListing"
import { ObjectType } from "../state/listing/generic-listing/index"

const InvoiceListing = () => {
    SideBar.activateMenu("invoice")

    if (AppContext.getAccount().attributes.onBoardingStatus === "pending") {
        return <Redirect to={{ pathname: "/" }} />
    }

    return (
        <div>
            <InvoicesTabs />
            <GenericListing
                objectType={ObjectType.INVOICES}
                additionalObjectTypes={[ObjectType.CREDIT_MEMOS]}
                selectableRows
            />
        </div>
    )
}

export default injectIntl(InvoiceListing)



// WEBPACK FOOTER //
// ./src/invoice/List.tsx